import * as React from 'react';
import * as _ from 'lodash';
import {
  hashObject,
  Image,
} from '@vcd-ecm-ui/Common';
import AdditionalDocumentViewer from '../../AdditionalDocumentViewer/AdditionalDocumentViewer';
import SideBySideViewerDocumentationTabProps from './sbsDocumentationTabProps.interface';
import '../../sidebyside-viewer.scss';

const SideBySideViewerDocumentationTab = ({
  certificate,
  editable,
}: SideBySideViewerDocumentationTabProps): JSX.Element => {
  const [additionalDocument, setAdditionalDocument] = React.useState(null);
  const [additionalDocumentIsOpen, setAdditionalDocumentIsOpen] = React.useState(false);

  // Show the Additional Document
  const showAdditionalDocument = (image: Image): void => {
    setAdditionalDocument(image);
    setAdditionalDocumentIsOpen(true);
  };

  // Get the List of Additional Documentation to be rendered
  const getAdditionalDocumentation = (): JSX.Element[] | JSX.Element => {
    const numberImages: number = certificate.supportingDocumentationImages ? certificate.supportingDocumentationImages.length : 0;

    if (!numberImages) {
      return (<></>);
    }

    let imageIndex = 0;

    // Loop through the Files
    return certificate.supportingDocumentationImages.map((image: Image) => {
      const { name } = image;
      const link: string = image.location;
      const key: string = hashObject(image);

      imageIndex += 1;

      // Use all Images
      if (imageIndex > 0) {
        // Generate the HTML to the File
        return (
          <div key={key} className="field100">
            {/* eslint-disable-next-line react/button-has-type */}
            <button type="button" onClick={(): void => showAdditionalDocument(image)}>
              <p id={`additional-document-${imageIndex}`} className="sbsAdditionalDocument">{name}</p>
            </button>
          </div>
        );
      }

      return null;
    });
  };

  return (
    <>
      <div id="additional-documentation-tab" className="sbsContentLeftTabContent">
        {getAdditionalDocumentation()}
      </div>
      <AdditionalDocumentViewer
        imageDocument={additionalDocument}
        isOpen={additionalDocumentIsOpen}
        setIsOpen={setAdditionalDocumentIsOpen}
      />
    </>
  );
};

export default SideBySideViewerDocumentationTab;
